import { simpleSet } from '@r/reducers/utils';

const setCalculationModeDrawerSystemsOptions = simpleSet as
  redux.reducers.calculationMode.settings.materials.drawerSystems.options;

export const options = setCalculationModeDrawerSystemsOptions(
  'SET_CALCULATION_MODE_DRAWER_SYSTEMS_OPTIONS',
  []
);
